import { render, staticRenderFns } from "./AssetStorePage.vue?vue&type=template&id=114a8b1e"
import script from "./AssetStorePage.vue?vue&type=script&lang=js"
export * from "./AssetStorePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports